import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-custom-deal-layout',
  templateUrl: './custom-deal-layout.component.html',
  styleUrls: ['./custom-deal-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDealLayoutComponent extends OnDestroyMixin {
  private _dataSource: any[];

  template_id = new UntypedFormControl(null);

  @Input() set dataSource(value: any[]) {
    this._dataSource = value;
    const [firstValue] = value;
    this.template_id.setValue(firstValue.id);
  }
  @Input() readonly: boolean;

  @Output() onValueChanged = new EventEmitter<{ template_id: number }>();

  get dataSource(): any[] {
    return this._dataSource;
  }

  constructor() {
    super();

    this.template_id.valueChanges
      .pipe(untilComponentDestroyed(this))
      .subscribe((value: number) => this.onValueChanged.emit({ template_id: value }));
  }
}
